import { FIELDS } from "./fields";
import { cellText } from "./sheet";

// The change history behind the Recent page. Kept by the API with the
// inventory itself; the panel gets the newest MAX_ENTRIES, newest first.
//
// An entry:
//   { id, at, user, action, channels: [{ id, channelName, partner }],
//     changes?: [{ key, label, from, to }], counts?: { added, updated },
//     note? }
// action: "add" | "duplicate" | "edit" | "delete" | "import" | "reset" | "undo"

export const MAX_ENTRIES = 500;

export const ACTION_LABELS = {
  add: "Added",
  duplicate: "Duplicated",
  edit: "Edited",
  delete: "Deleted",
  import: "Imported",
  reset: "Restored sample data",
  undo: "Undid",
};

// Fields a person edits; dates and ids are bookkeeping, not changes
const TRACKED = FIELDS.filter((f) => !f.meta);

// What differs between two versions of a channel, as the sheet would show it
export function diffChannel(before, after) {
  const changes = [];
  TRACKED.forEach((f) => {
    const from = cellText(before, f);
    const to = cellText(after, f);
    if (from !== to) changes.push({ key: f.key, label: f.label, from, to });
  });
  return changes;
}

export const channelRef = (c) => ({
  id: c.id,
  channelName: c.channelName,
  partner: c.partner,
});
